import styled from "styled-components";
import { Select, MenuItem } from "@material-ui/core";
import { MainTableRow, primary, secondary } from "../shared/Style/Style";

export const ShareLinksTableRow = styled(MainTableRow)`
  grid-template-columns: 1.2fr 2fr 1.6fr 0.8fr 1fr 0.5fr;
  grid-gap: 10px;
  align-items: center;
  text-align: center;
`;

export const ShareLinksListItem = styled(ShareLinksTableRow)`
  min-height: 64px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ShortCodeCell = styled.span`
  font-family: monospace;
  font-weight: 600;
`;

export const ShareUrlCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  & span {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }
`;

export const FilterSelect = styled(Select).attrs({
  MenuProps: {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "auto",
      },
    },
  },
})`
  width: 100%;
  height: 32px;
  background-color: white;

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 2px solid ${primary} !important;
  }
  & .MuiSelect-select {
    font-size: 12px;
    font-weight: 600;
    background-color: white;
  }
  & .MuiSelect-icon {
    color: ${primary};
  }
`;

export const FilterMenuItem = styled(MenuItem)`
  padding: 2px 8px;

  &.Mui-selected,
  &.Mui-selected:hover,
  &.Mui-focusVisible {
    background-color: white !important;
  }
  & .MuiListItemText-primary {
    font-size: 12px;
  }
  & .MuiRadio-root {
    color: ${primary};
    padding: 2px;
  }
  & .MuiRadio-colorSecondary.Mui-checked {
    color: ${primary};
  }
`;

export const StatusChip = styled.span<{ active?: boolean }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ active }) => (active ? "#fff" : "#fff")};
  background-color: ${({ active }) => (active ? primary : secondary)};
`;

export const ShareLinkForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;
